import Dev from './dev';
import Prod from './prod';


let outConfig = {}

switch (true) {
    case window.location.hostname.indexOf('localhost') !== -1:
        outConfig = Dev;

        break;
    case window.location.hostname.indexOf('localhost') === -1:
        outConfig = Prod;

        break;

    default:
        outConfig = Dev;

        break;
}


export default outConfig;


// WEBPACK FOOTER //
// ./src/config/index.js